export default (params) => ({
  trigger: {
    name: 'content_blocks.manufacturers_specifications.view',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'product_page',
          'information_overlay',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
      },
    },
    nonInt: true,
  },
});
